import { render } from "./AddHormoneDialog.vue?vue&type=template&id=c2e5e5a0&scoped=true"
import script from "./AddHormoneDialog.vue?vue&type=script&lang=js"
export * from "./AddHormoneDialog.vue?vue&type=script&lang=js"

import "./AddHormoneDialog.vue?vue&type=style&index=0&id=c2e5e5a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2e5e5a0"]])

export default __exports__